export function contractorAgreementSignedPdfStoragePath(agreement: {
  id: string;
  applicantId: string;
  signedPdfPath?: string | null;
}): string {
  const stored = (agreement.signedPdfPath || '').trim();
  if (stored) return stored;
  return `contractor-onboard/${agreement.applicantId}/agreement/${agreement.id}-signed.pdf`;
}

export function contractorAgreementPdfFileName(fields: {
  contractorFirstName?: string;
  contractorLastName?: string;
}): string {
  const name = `${fields.contractorFirstName || ''} ${fields.contractorLastName || ''}`.trim() || 'contractor';
  const slug = name.replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-+|-+$/g, '').toLowerCase();
  return `${slug || 'contractor'}-1099-agreement.pdf`;
}
